export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }
      return config;
    },
    err => {
      if (err.response.status === 401) {
        store.dispatch('Logout')

      }

      return Promise.reject(err)
    }
  );
}
